module.exports = "/_next/static/images/15-2b92fcf094192e5daffe5aece6d35d4e.png";